/** @file Thai catalog part of area E5 (W3-03), partial; replaced whole by that area. */

/** The `editMesh` and `paintWeights` tool blocks (spread into `tools`); partial, English fills the gaps. S0 composes it into `th`. */
export const meshToolsTh = {
  editMesh: {
    title: 'แก้เมช',
    clickMode: 'โหมดคลิก',
    modify: 'แก้ไข',
    create: 'เพิ่ม',
    remove: 'ลบ',
    showIds: 'เลขจุด',
    keepImage: 'ให้ภาพอยู่กับที่',
    deleteVertices: 'ลบจุด',
    retriangulate: 'สร้างสามเหลี่ยมใหม่',
    outlineHull: 'ใช้ขอบนอกเป็น hull',
    flipEdge: 'กลับเส้นทแยง',
    addTriangle: 'เพิ่มสามเหลี่ยม',
    removeTriangle: 'ลบสามเหลี่ยม',
    noMesh: 'เลือก slot ที่แสดงเมช',
    setupOnly: 'เพิ่มหรือลบจุดได้ในโหมด Setup; โหมด Animate ใช้คีย์ deform',
    pickAnimation: 'เลือก animation ก่อนคีย์ deform',
    autoKeyOff: 'ปิด auto-key อยู่ และเฟรมนี้ไม่มีคีย์ deform',
    selectVertices: 'เลือกจุดก่อน',
    selectTwo: 'เลือกสองจุดของเส้นด้านใน',
    selectThree: 'เลือกสามจุด',
    hullTooSmall: 'ขอบนอกต้องมีอย่างน้อย 3 จุด',
    topologyFailed: 'ขอบนอกตัดกันเองหรือไม่มีพื้นที่: แก้ก่อน',
    noOutline: 'สามเหลี่ยมไม่ได้เป็นขอบนอกเดียว',
    noEdge: 'สองจุดนี้ไม่มีเส้นที่กลับได้',
    triangleExists: 'มีสามเหลี่ยมนี้แล้ว',
    noTriangle: 'จุดเหล่านี้ไม่ใช่สามเหลี่ยมของเมช หรือเป็นอันสุดท้าย',
  },
  paintWeights: {
    title: 'ระบายน้ำหนัก',
    rigid: 'เมชนี้เป็นแบบ rigid: เปลี่ยนเป็น skinned ในแผง Weights ก่อน',
    mode: 'แปรง',
    add: 'เพิ่ม',
    subtract: 'ลด',
    replace: 'แทนที่',
    smooth: 'เกลี่ย',
    bone: 'bone ที่ระบาย',
    radius: 'รัศมี (px)',
    strength: 'ความแรง',
    hardness: 'ความแข็ง',
    value: 'ค่า',
    autoNormalize: 'ปรับรวมเป็น 1 อัตโนมัติ',
    staleBind: 'การผูกของเมชนี้เก่ากว่าท่า setup ของ bone: กด "ผูกใหม่ที่ท่า setup" (แผง Weights) ก่อนระบาย ภาพที่ท่า setup จะคงเดิม',
  },
} as const;
